export const { VITE_API_URL, VITE_MUI_X_PRO_KEY, VITE_MAX_FILE_SIZE, VITE_MAX_FILENAME_LENGTH } =
  import.meta.env;

export const RULESENGINE_ENV = Object.freeze({
  LOCAL: 'localhost',
  DEV: 'rulesengine.dev',
  QA: 'rulesengine.qa',
  UAT: 'rulesengine.uat',
  PROD: 'rulesengine.claconnect.com'
});

export type RULESENGINE_ENV = (typeof RULESENGINE_ENV)[keyof typeof RULESENGINE_ENV];

const ENV_HOST_ALIASES: Record<RULESENGINE_ENV, string[]> = {
  [RULESENGINE_ENV.LOCAL]: ['localhost'],
  [RULESENGINE_ENV.DEV]: ['clc-rules-hub.dev', '.dev.claitdev.com'],
  [RULESENGINE_ENV.QA]: ['clc-rules-hub.qa', '.qa.claitdev.com'],
  [RULESENGINE_ENV.UAT]: ['clc-rules-hub.uat', '.uat.claitdev.com'],
  [RULESENGINE_ENV.PROD]: ['clc-rules-hub.claconnect.com', '.claconnect.com']
};

/**
 * Determines the current environment based on the window location hostname.
 * Matches the hostname against known aliases per environment (for example
 * rulesengine.dev and *.dev.claitdev.com for DEV).
 * Returns the corresponding environment enum value or defaults to LOCAL if no match is found.
 */
export function getRulesEngineEnv(): RULESENGINE_ENV {
  const hostname = window.location.hostname;
  return (
    (Object.keys(ENV_HOST_ALIASES) as RULESENGINE_ENV[]).find((env) =>
      ENV_HOST_ALIASES[env].some((alias) => hostname.includes(alias))
    ) || RULESENGINE_ENV.LOCAL
  );
}
